export const environment = {
  production: true,
  apiUrl: 'https://dpcccems.nic.in/dlcpcb-api/api',
  apiBaseUrl: 'https://dpcccems.nic.in/dlcpcb-api/',
  apiBasePath: 'https://dpcccems.nic.in/dlcpcb-api/',

  state: 'Delhi',
  stateCode: 'DPCC',
  logo: 'dlcpcb-logo.png',
  halfLogoColor: 'dlLogoHalfColor.png',
  halfLogoWhite: 'dlLogoHalfWhite.png'
};
